import React from "react"

function TidepoolCell({ loading, children }) {
    if (loading) {
        return <span className="spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true" />
    }
    return children
}

function ItemCard({ item }) {
    return (
        <div className="card border mb-3">
            <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-start mb-3">
                    <div className="fw-semibold text-dark">{item.code}</div>
                    <div className="d-flex gap-2">
                        {item.inWeight && (
                            <span className="badge bg-primary rounded-pill">
                                {item.inWeight}
                            </span>
                        )}
                        {item.boxUp && (
                            <span className="badge bg-success rounded-pill">
                                {item.boxUp}
                            </span>
                        )}
                    </div>
                </div>

                <div className="mb-3">
                    <div className="fs-6 fw-semibold text-dark">
                        {item.species || item.description}
                    </div>
                    {item.method && (
                        <div className="fs-6 text-secondary">{item.method}</div>
                    )}
                </div>

                {item.fish && (
                    <div className="fs-6 text-secondary mb-2">
                        <span className="fw-semibold">Fish:</span> {item.fish}
                    </div>
                )}

                <div className="d-flex justify-content-between fs-6 text-secondary">
                    <div>
                        <span className="fw-semibold">Sign:</span>{" "}
                        <TidepoolCell loading={item.tidepoolLoading}>{item.sign}</TidepoolCell>
                    </div>
                    <div>
                        <span className="fw-semibold">Date:</span>{" "}
                        <TidepoolCell loading={item.tidepoolLoading}>{item.date}</TidepoolCell>
                    </div>
                </div>
            </div>
        </div>
    )
}

function TableSection({ title, items, badgeColor }) {
    return (
        <div className="mb-4">
            <div className="d-lg-none v2-mobile-list">
                <div className="mb-3">
                    <span className={`badge ${badgeColor} rounded-pill text-white`}>
                        {title}
                    </span>
                </div>
                <div className="d-flex flex-column gap-3">
                    {items.map((item, index) => (
                        <ItemCard key={index} item={item} />
                    ))}
                </div>
            </div>

            <div className="d-none d-lg-block">
                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr className="border-bottom">
                                <th className="py-3">
                                    <span className={`badge ${badgeColor} text-white`}>
                                        {title}
                                    </span>
                                </th>
                                <th className="py-3 text-uppercase small fw-semibold text-secondary">
                                    DESCRIPTION
                                </th>
                                <th className="py-3 text-uppercase small fw-semibold text-secondary">
                                    FISH
                                </th>
                                <th className="py-3 text-uppercase small fw-semibold text-secondary">
                                    IN WEIGHT
                                </th>
                                <th className="py-3 text-uppercase small fw-semibold text-secondary">
                                    BOX UP
                                </th>
                                <th className="py-3 text-uppercase small fw-semibold text-secondary">
                                    SIGN
                                </th>
                                <th className="py-3 text-uppercase small fw-semibold text-secondary">
                                    DATE
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, index) => (
                                <tr key={index}>
                                    <td className="fw-semibold text-dark">{item.code}</td>
                                    <td>
                                        <div>
                                            <div className="fs-6 fw-semibold text-dark">
                                                {item.species || item.description}
                                            </div>
                                            {item.method && (
                                                <div className="fs-6 text-secondary">
                                                    {item.method}
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                    <td className="text-secondary">{item.fish}</td>
                                    <td>
                                        {item.inWeight && (
                                            <span className="badge bg-primary rounded-pill">
                                                {item.inWeight}
                                            </span>
                                        )}
                                    </td>
                                    <td>
                                        {item.boxUp && (
                                            <span className="badge bg-success rounded-pill">
                                                {item.boxUp}
                                            </span>
                                        )}
                                    </td>
                                    <td className="text-secondary">
                                        <TidepoolCell loading={item.tidepoolLoading}>{item.sign}</TidepoolCell>
                                    </td>
                                    <td className="text-secondary">
                                        <TidepoolCell loading={item.tidepoolLoading}>{item.date}</TidepoolCell>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default function ProcessBoxUpTable({ cannedItems, frozenItems }) {
    return (
        <div className="card rounded shadow-sm border">
            <div className="card-body p-4">
                <TableSection title="Canned" items={cannedItems} badgeColor="bg-danger" />
                <TableSection title="Frozen" items={frozenItems} badgeColor="bg-primary" />
            </div>
        </div>
    )
}
